import {
	fetchPlayerSeasonStatsSuccess,
	fetchPlayerSeasonStats,
	fetchPlayerSeasonStatsFailed,
} from "modules/actions";
import {RequestState} from "modules/enums";
import {createReducer} from "redux-act";

interface IPlayerSeasonStatsStore {
	stats: ReturnType<typeof fetchPlayerSeasonStatsSuccess>["payload"];
	loadingState: RequestState;
}

const defaultState: IPlayerSeasonStatsStore = {
	stats: {
		seasonsStats: [],
	},
	loadingState: RequestState.IDLE,
};

export const playerSeasonStats = createReducer({}, defaultState)
	.on(fetchPlayerSeasonStats, (state) => ({
		...state,
		loadingState: RequestState.REQUESTED,
	}))
	.on(fetchPlayerSeasonStatsSuccess, (state, payload) => ({
		...state,
		stats: {
			...state.stats,
			...payload,
		},
		loadingState: RequestState.RECEIVED,
	}))
	.on(fetchPlayerSeasonStatsFailed, (state) => ({
		...state,
		loadingState: RequestState.RECEIVED,
	}));
